// Zentrale, typsichere Env-Zugriffe. Nur ÖFFENTLICHE Client-Konfiguration.
export const SUPABASE_URL = (import.meta.env.VITE_SUPABASE_URL ?? "").trim();
export const SUPABASE_ANON_KEY = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? "").trim();
// Nur der ÖFFENTLICHE VAPID-Key darf hier stehen (nie der private).
export const VAPID_PUBLIC_KEY = (import.meta.env.VITE_VAPID_PUBLIC_KEY ?? "").trim();

export const HAS_SUPABASE_CONFIG = SUPABASE_URL.length > 0 && SUPABASE_ANON_KEY.length > 0;
export const HAS_VAPID = VAPID_PUBLIC_KEY.length > 0;
